import React, { useState, useEffect, useRef } from "react"
import Swal from "sweetalert2"
import {
  Alert,
  Button,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  InputGroup,
  InputGroupText,
} from "reactstrap"
import propTypes from "prop-types"
import AsyncSelect from "react-select/async"
import { useQueryClient } from "@tanstack/react-query"
import { getCustomer, getCustomers } from "services/customers"
import { updatePartialTicket, getCashCounterRegister } from "services/tickets"
import { Loading } from "../"
import { getLimitForCashCut } from "services/periodic-tasks"
import "assets/scss/custom/components/payment-flow-modal.scss"

const OutPaiding = ({ isOpen, toggleModal, ticketPaying, setFinishSold }) => {
  const queryClient = useQueryClient()
  const [discountAmount, setDiscountAmount] = useState(0)
  const [cashAmount, setCashAmount] = useState(0)
  const [tarjetaAmount, setTarjetaAmount] = useState(0)
  const [transferAmount, setTransferAmount] = useState(0)
  const [pagareAmount, setPagareAmount] = useState(0)
  const [otherAmount, setOtherAmount] = useState(0)
  const [texOther, setTexOther] = useState("")

  const [discountt, setDiscountt] = useState(0)
  const [subtotall, setSubtotall] = useState(0)
  const [creditAvailable, setCreditAvailable] = useState(0)
  const [isLoading, setIsLoading] = useState(true)
  const [limitCash, setLimitCash] = useState()
  const [cashCounterRegister, setCashCounterRegister] = useState()
  const [restMoney, setRestMoney] = useState(0)
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)
  const [isPagareCustomerModalOpen, setIsPagareCustomerModalOpen] = useState(false)
  const [pagareCustomer, setPagareCustomer] = useState(null)
  const [isFinalizingPayment, setIsFinalizingPayment] = useState(false)
  const paymentInputRefs = {
    cash: useRef(null),
    card: useRef(null),
    transfer: useRef(null),
    pagare: useRef(null),
    other: useRef(null),
  }

  const getTicketTotalAmount = (ticket) => {
    const ticketTotal = Number(ticket?.total)
    if (Number.isFinite(ticketTotal) && ticketTotal > 0) {
      return ticketTotal
    }

    return Math.max(Number(ticket?.subtotal || 0) - Number(ticket?.discount || 0), 0)
  }

  const setExclusivePaymentAmount = (paymentMethod, amount) => {
    setCashAmount(paymentMethod === "cash" ? amount : 0)
    setTarjetaAmount(paymentMethod === "card" ? amount : 0)
    setTransferAmount(paymentMethod === "transfer" ? amount : 0)
    setPagareAmount(paymentMethod === "pagare" ? amount : 0)
    setOtherAmount(paymentMethod === "other" ? amount : 0)
  }

  const cyclePaymentAmount = () => {
    if (!selectedPaymentMethod) {
      return
    }

    const amount = totalWhitDiscount
    const nextPaymentMethod = selectedPaymentMethod === "cash"
      ? "card"
      : selectedPaymentMethod === "card"
      ? "transfer"
      : selectedPaymentMethod === "transfer"
      ? "pagare"
      : selectedPaymentMethod === "pagare"
      ? "other"
      : "cash"

    setExclusivePaymentAmount(nextPaymentMethod, amount)
    setSelectedPaymentMethod(nextPaymentMethod)
    window.setTimeout(() => paymentInputRefs[nextPaymentMethod]?.current?.focus(), 0)
  }

  const handlePaymentMethodClick = (paymentMethod) => {
    setSelectedPaymentMethod(paymentMethod)
  }

  const handlePaymentMethodKeyDown = (event) => {
    if (event.key !== "Tab" || !selectedPaymentMethod) {
      return
    }

    event.preventDefault()
    cyclePaymentAmount()
  }

  const getPaymentInputStyle = (paymentMethod) => {
    if (selectedPaymentMethod !== paymentMethod) {
      return undefined
    }

    return {
      borderColor: "#0d6efd",
      boxShadow: "0 0 0 0.2rem rgba(13, 110, 253, 0.25)",
      backgroundColor: "#e7f1ff",
      color: "#084298",
      fontWeight: 600,
    }
  }

  const getPaymentInputValue = (amount) => {
    const numericAmount = Number(amount || 0)
    return numericAmount === 0 ? "" : numericAmount
  }

  const resetPaymentState = () => {
    setDiscountAmount(0)
    setCashAmount(0)
    setTarjetaAmount(0)
    setTransferAmount(0)
    setPagareAmount(0)
    setOtherAmount(0)
    setTexOther("")
    setDiscountt(0)
    setSubtotall(0)
    setCreditAvailable(0)
    setLimitCash(undefined)
    setCashCounterRegister(undefined)
    setRestMoney(0)
    setSelectedPaymentMethod(null)
    setIsPagareCustomerModalOpen(false)
    setPagareCustomer(null)
    setIsFinalizingPayment(false)
  }

  const currentCustomerOption = ticketPaying?.customer
    ? { value: ticketPaying.customer.id, label: ticketPaying.customer.name }
    : null

  const loadCustomerOptions = async (inputValue) => {
    const params = { per_page: 30, ordering: "name" }
    if (inputValue && inputValue.trim()) params.search = inputValue.trim()
    const data = await getCustomers(params)
    return (data?.results || []).map((customer) => ({ value: customer.id, label: customer.name }))
  }

  const doRequestWithRetry = async (asyncFn, args = [], attempts = 3, timeoutMs = 6000, label = "request") => {
    const withTimeout = (promise, ms) =>
      new Promise((resolve, reject) => {
        const id = setTimeout(() => reject(new Error("timeout")), ms)
        promise
          .then((res) => {
            clearTimeout(id)
            resolve(res)
          })
          .catch((err) => {
            clearTimeout(id)
            reject(err)
          })
      })

    let attempt = 0
    let lastError = null
    while (attempt < attempts) {
      attempt += 1
      try {
        console.info(`[OutPaiding] ${label} attempt ${attempt} start`)
        const result = await withTimeout(asyncFn(...args), timeoutMs)
        console.info(`[OutPaiding] ${label} attempt ${attempt} success`, result)
        return result
      } catch (err) {
        lastError = err
        console.error(`[OutPaiding] ${label} attempt ${attempt} failed`, err)
        if (attempt < attempts) console.info(`[OutPaiding] ${label} retrying...`)
      }
    }
    console.error(`[OutPaiding] ${label} failed after ${attempts} attempts`, lastError)
    throw lastError
  }

  const totalResivido = 0 + cashAmount + tarjetaAmount + transferAmount + pagareAmount + otherAmount
  const totalDiscount = discountAmount + Number(discountt)
  const totalWhitDiscount = subtotall - (discountAmount + Number(discountt))
  const cashToRegister = Math.max(cashAmount - restMoney, 0)
  const projectedCashRegister = Number(cashCounterRegister || 0) + cashToRegister
  const cashLimitThreshold = 2000
  const hasCashLimit = Number.isFinite(limitCash) && limitCash > 0
  const isCloseToCashLimit = hasCashLimit && cashToRegister > 0 
  && projectedCashRegister >= limitCash - cashLimitThreshold && projectedCashRegister < limitCash
  
  const isAtOrAboveCashLimit = hasCashLimit && cashToRegister > 0 && projectedCashRegister >= limitCash

  useEffect(() => {
    let isActive = true

    if (!isOpen || !ticketPaying) {
      resetPaymentState()
      setIsLoading(true)
      return undefined
    }

    resetPaymentState()
    setIsLoading(true)

    console.info("[OutPaiding] ticketPaying received", {
      ticketId: ticketPaying?.id,
      customerId: ticketPaying?.customer?.id,
      userId: ticketPaying?.user?.id,
      subtotal: ticketPaying?.subtotal,
      discount: ticketPaying?.discount,
    })

    setSubtotall(Number(ticketPaying.subtotal))
    setDiscountt(Number(ticketPaying.discount))
    setExclusivePaymentAmount("cash", getTicketTotalAmount(ticketPaying))
    setSelectedPaymentMethod("cash")

    console.info("[OutPaiding] requesting customer and other resources")
    ;(async () => {
      try {
        const customer = await doRequestWithRetry(getCustomer, [ticketPaying.customer?.id], 3, 6000, "getCustomer")
        if (isActive) {
          setCreditAvailable(Number(customer.available_credit))
        }
      } catch (err) {
        console.error("[OutPaiding] getCustomer failed after retries", err)
      }

      try {
        const limit = await doRequestWithRetry(getLimitForCashCut, [], 3, 6000, "getLimitForCashCut")
        if (isActive) {
          setLimitCash(Number(limit.results?.[0]?.limit || 0))
        }
      } catch (err) {
        console.error("[OutPaiding] getLimitForCashCut failed after retries", err)
      }

      try {
        const cashRegister = await doRequestWithRetry(
          getCashCounterRegister,
          [ticketPaying.user?.id],
          3,
          6000,
          "getCashCounterRegister"
        )
        if (isActive) {
          setCashCounterRegister(Number(cashRegister.cash))
        }
      } catch (err) {
        console.error("[OutPaiding] getCashCounterRegister failed after retries", err)
      }

      if (isActive) {
        setIsLoading(false)
      }
    })()

    return () => {
      isActive = false
    }
  }, [isOpen, ticketPaying?.id])

  useEffect(() => {
    if (!isOpen || isLoading) {
      return
    }

    setSelectedPaymentMethod("cash")
    window.setTimeout(() => {
      paymentInputRefs.cash.current?.focus()
      paymentInputRefs.cash.current?.select()
    }, 0)
  }, [isOpen, isLoading, ticketPaying?.id])

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    },
  })

  //
  // const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)

  // const paymentMethods = [
  //   { value: "01 - Efectivo.", label: "Efectivo" },
  //   { value: "02 - Cheque nominativo.", label: "Cheque nominativo" },
  //   { value: "03 - Transferencia electrónica de fondos.", label: "Transferencia electrónica de fondos" },
  //   { value: "04 - Tarjeta de crédito.", label: "Tarjeta de crédito" },
  //   { value: "99 - Por definir.", label: "Por definir" },
  // ]

  useEffect(() => {
    const calculatedChange = cashAmount - totalWhitDiscount
    setRestMoney(calculatedChange >= 0 ? calculatedChange : 0)
  }, [cashAmount, totalDiscount])

  const finalizarVenta = async (pagareCustomerId = null) => {
    console.info("[OutPaiding] finalizarVenta started", {
      ticketId: ticketPaying?.id,
      totalWhitDiscount,
      totalResivido,
      limitCash,
      cashCounterRegister,
      cashAmount,
      tarjetaAmount,
      transferAmount,
      otherAmount,
      restMoney,
    })

    if (totalWhitDiscount > totalResivido) {
      console.warn("[OutPaiding] insufficient received amount", {
        totalWhitDiscount,
        totalResivido,
      })
      Toast.fire({
        icon: "error",
        title: "Saldo Insuficiente",
      })
      return
    }

    if (pagareAmount > 0 && !pagareCustomerId) {
      setPagareCustomer(currentCustomerOption)
      setIsPagareCustomerModalOpen(true)
      return
    }

    let selectedCustomerCredit = Number(creditAvailable || 0)
    if (pagareAmount > 0 && pagareCustomerId && pagareCustomerId !== ticketPaying.customer?.id) {
      try {
        const customer = await doRequestWithRetry(getCustomer, [pagareCustomerId], 3, 6000, "getPagareCustomer")
        selectedCustomerCredit = Number(customer.available_credit || 0)
        setCreditAvailable(selectedCustomerCredit)
      } catch (err) {
        Swal.fire({
          title: "No se pudo validar el cliente",
          text: "Intenta nuevamente antes de dejar la venta en pagare.",
          icon: "error",
          confirmButtonColor: "#6fc33a",
        })
        return
      }
    }

    if (pagareAmount > selectedCustomerCredit) {
      Swal.fire({
        title: "Credito insuficiente",
        text: "El monto del pagare supera el credito disponible del cliente.",
        icon: "error",
        confirmButtonColor: "#6fc33a",
      })
      return
    }

    if (isAtOrAboveCashLimit) {
      console.warn("[OutPaiding] cash limit would be reached or exceeded", {
        limitCash,
        cashCounterRegister,
        projectedCashRegister,
        cashToRegister,
      })
      Swal.fire({
        title: "Límite de efectivo alcanzado",
        text: "No se puede cobrar porque el dinero en caja llegó al límite. Mueve o retira efectivo para continuar.",
        icon: "error",
        confirmButtonColor: "#6fc33a",
      })
      return
    }

    if (totalWhitDiscount <= totalResivido) {
      console.info("[OutPaiding] validations passed, building request payload")
      const payload = {
        is_paid: true,
        is_pending: false,
        is_receivable: pagareAmount > 0,
        ...(pagareAmount > 0 && pagareCustomerId ? { customer: pagareCustomerId } : {}),
        discount: totalDiscount,
        ticket_payments: [
          { pay_method: "01 - Efectivo.", total_amount: cashAmount - restMoney },
          { pay_method: "28 - Tarjeta de débito.", total_amount: tarjetaAmount },
          { pay_method: "03 - Transferencia electrónica de fondos.", total_amount: transferAmount },
          { pay_method: "PAGARE - Pagare.", total_amount: pagareAmount },
          { pay_method: "99 - Por definir.", total_amount: otherAmount, description_other: texOther },
        ].filter((payment) => payment.total_amount > 0),
      }

      console.info("[OutPaiding] payload ready", payload)

      const withTimeout = (promise, ms) =>
        new Promise((resolve, reject) => {
          const id = setTimeout(() => reject(new Error("timeout")), ms)
          promise
            .then((res) => {
              clearTimeout(id)
              resolve(res)
            })
            .catch((err) => {
              clearTimeout(id)
              reject(err)
            })
        })

      const maxAttempts = 2
      let attempt = 0
      let success = false
      let lastError = null
      setIsFinalizingPayment(true)

      while (attempt < maxAttempts && !success) {
        attempt += 1
        console.info(`[OutPaiding] updatePartialTicket attempt ${attempt} started`, {
          ticketId: ticketPaying?.id,
          timeoutMs: 6000,
        })
        try {
          // await the request but fail fast if it hangs (6s)
          const response = await withTimeout(updatePartialTicket(ticketPaying.id, payload), 6000)
          console.info(`[OutPaiding] updatePartialTicket attempt ${attempt} succeeded`, response)
          success = true
        } catch (err) {
          lastError = err
          console.error(`[OutPaiding] updatePartialTicket attempt ${attempt} failed`, err)
          if (attempt < maxAttempts) console.info("[OutPaiding] retrying updatePartialTicket")
        }
      }

      if (success) {
        console.info("[OutPaiding] sale completed successfully")
        queryClient.invalidateQueries(["pendingTickets"])
        queryClient.invalidateQueries(["ticketsNoPaid"])
        queryClient.invalidateQueries(["ticketsReceivable"])
        queryClient.invalidateQueries(["cash-register-balance"])
        setRestMoney(0)
        toggleModal()
        setFinishSold(true)
        Toast.fire({
          icon: "success",
          title: pagareAmount > 0 ? "Pagare registrado correctamente" : "Venta realizada correcta",
        })
      } else {
        setIsFinalizingPayment(false)
        console.error("[OutPaiding] sale failed after retries", lastError)
        Swal.fire({
          title: "Error al cobrar venta, intenta nuevamente en unos minutos",
          text: lastError?.message ? String(lastError.message) : JSON.stringify(lastError),
          icon: "error",
          confirmButtonColor: "#6fc33a",
        })
      }
      return
    }
    console.info("[OutPaiding] finalizarVenta ended without sending request", {
      limitCash,
      cashCounterRegister,
      totalWhitDiscount,
      totalResivido,
    })
  }

  const confirmarClientePagare = () => {
    if (!pagareCustomer?.value) {
      Swal.fire({
        title: "Selecciona un cliente",
        text: "El pagare debe quedar asignado a un cliente.",
        icon: "warning",
        confirmButtonColor: "#6fc33a",
      })
      return
    }

    setIsPagareCustomerModalOpen(false)
    finalizarVenta(pagareCustomer.value)
  }

  useEffect(() => {
    setDiscountAmount(discountAmount)
    setCashAmount(cashAmount)
    setTarjetaAmount(tarjetaAmount)
    setTransferAmount(transferAmount)
    setPagareAmount(pagareAmount)
    setOtherAmount(otherAmount)
  }, [discountAmount, cashAmount, tarjetaAmount, transferAmount, pagareAmount, otherAmount])

  return (
    <Modal isOpen={isOpen} toggle={toggleModal} backdrop="static" centered size="lg" className="payment-flow-modal">
      {isLoading || isFinalizingPayment ? (
        <div className="text-center py-5">
          <Loading isLoading size={2} />
          {isFinalizingPayment && (
            <div className="mt-3 fw-semibold">
              {pagareAmount > 0 ? "Procesando pago en cuenta por cobrar..." : "Procesando pago..."}
            </div>
          )}
        </div>
      ) : (
        <>
          <ModalHeader toggle={toggleModal}>Aplicar Descuento</ModalHeader>
          <ModalBody
            onMouseDown={(event) => {
              if (!event.target.closest("[data-payment-method]")) {
                setSelectedPaymentMethod(null)
              }
            }}
          >
            {isAtOrAboveCashLimit && (
              <Alert color="danger" className="mb-3">
                <div>
                  <strong>Límite de efectivo en caja registradora:</strong> {limitCash.toLocaleString("es-MX", 
                    { style: "currency", currency: "MXN" })}
                </div>
                <div>
                  Caja actual: {Number(cashCounterRegister || 0).toLocaleString("es-MX", 
                    { style: "currency", currency: "MXN" })}
                </div>
                <div>
                  Proyectado al cobrar: {projectedCashRegister.toLocaleString("es-MX", 
                    { style: "currency", currency: "MXN" })}
                </div>
                {isCloseToCashLimit && <div>Mueve o retira efectivo para evitar bloquear cobros.</div>}
                {isAtOrAboveCashLimit && <div>No se puede cobrar en efectivo<br/>
                  El efectivo en caja llegó a su límite.</div>}
              </Alert>
            )}
            <div className="payment-flow-layout">
              <div className="payment-flow-panel">
            <Row className="g-3 align-items-center">
              <Col className="text-end">
                <Label>Monto a Descontar:</Label>
              </Col>
              <Col>
                <InputGroup>
                  <Input
                    type="number"
                    id="discountAmount"
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)
                      setDiscountAmount(isNaN(value) ? 0 : value)
                    }}
                  />
                  <InputGroupText>$</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <br />
            <Label>
              <h4>Montos por Método de Pago</h4>
            </Label>
            <Row className="g-3 align-items-center">
              <Col className="text-end">
                <Label>Efectivo:</Label>
              </Col>
              <Col>
                <InputGroup>
                  <Input
                    type="number"
                    id="cashAmount"
                    innerRef={paymentInputRefs.cash}
                    data-payment-method="cash"
                    value={getPaymentInputValue(cashAmount)}
                    style={getPaymentInputStyle("cash")}
                    onClick={() => handlePaymentMethodClick("cash")}
                    onFocus={() => handlePaymentMethodClick("cash")}
                    onKeyDown={handlePaymentMethodKeyDown}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)
                      setCashAmount(isNaN(value) ? 0 : Math.abs(value))
                    }}
                  />
                  <InputGroupText>$</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <br />
            <Row className="g-3 align-items-center">
              <Col className="text-end">
                <Label>Tarjeta Debito/Credito:</Label>
              </Col>
              <Col>
                <InputGroup>
                  <Input
                    type="number"
                    id="tarjetaAmount"
                    innerRef={paymentInputRefs.card}
                    data-payment-method="card"
                    value={getPaymentInputValue(tarjetaAmount)}
                    style={getPaymentInputStyle("card")}
                    onClick={() => handlePaymentMethodClick("card")}
                    onFocus={() => handlePaymentMethodClick("card")}
                    onKeyDown={handlePaymentMethodKeyDown}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)
                      setTarjetaAmount(isNaN(value) ? 0 : Math.abs(value))
                    }}
                  />
                  <InputGroupText>$</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <br />
            <Row className="g-3 align-items-center">
              <Col className="text-end">
                <Label>Transferencia Electronica:</Label>
              </Col>
              <Col>
                <InputGroup>
                  <Input
                    type="number"
                    id="transferAmount"
                    innerRef={paymentInputRefs.transfer}
                    data-payment-method="transfer"
                    value={getPaymentInputValue(transferAmount)}
                    style={getPaymentInputStyle("transfer")}
                    onClick={() => handlePaymentMethodClick("transfer")}
                    onFocus={() => handlePaymentMethodClick("transfer")}
                    onKeyDown={handlePaymentMethodKeyDown}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)
                      setTransferAmount(isNaN(value) ? 0 : Math.abs(value))
                    }}
                  />
                  <InputGroupText>$</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <br />
            <Row className="g-3 align-items-center">
              <Col className="text-end">
                <Label>Pagare:</Label>
              </Col>
              <Col>
                <InputGroup>
                  <Input
                    type="number"
                    id="pagareAmount"
                    innerRef={paymentInputRefs.pagare}
                    data-payment-method="pagare"
                    value={getPaymentInputValue(pagareAmount)}
                    style={getPaymentInputStyle("pagare")}
                    onClick={() => handlePaymentMethodClick("pagare")}
                    onFocus={() => handlePaymentMethodClick("pagare")}
                    onKeyDown={handlePaymentMethodKeyDown}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)
                      setPagareAmount(isNaN(value) ? 0 : Math.abs(value))
                    }}
                  />
                  <InputGroupText>$</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <br />
            <Row className="g-3 align-items-center payment-flow-other-row">
              <Col>
                <Input
                  type="text"
                  id="otherDescription"
                  onChange={(e) => setTexOther(e.target.value)}
                  placeholder="Otros..."
                  className="text-end"
                />
              </Col>
              <Col>
                <InputGroup>
                  <Input
                    type="number"
                    id="otherAmount"
                    innerRef={paymentInputRefs.other}
                    data-payment-method="other"
                    value={getPaymentInputValue(otherAmount)}
                    style={getPaymentInputStyle("other")}
                    onClick={() => handlePaymentMethodClick("other")}
                    onFocus={() => handlePaymentMethodClick("other")}
                    onKeyDown={handlePaymentMethodKeyDown}
                    onChange={(e) => {
                      const value = parseFloat(e.target.value)
                      setOtherAmount(isNaN(value) ? 0 : Math.abs(value))
                    }}
                  />
                  <InputGroupText>$</InputGroupText>
                </InputGroup>
              </Col>
            </Row>
            <br />
              </div>
              <div className="payment-flow-summary">
                <div className="payment-flow-summary-row">
                  <span>Subtotal</span>
                  <strong>{Number(subtotall).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}</strong>
                </div>
                <div className="payment-flow-summary-row">
                  <span>Descuento</span>
                  <strong>
                    {Number(totalDiscount).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
                  </strong>
                </div>
                <div className="payment-flow-summary-row total">
                  <span>Total</span>
                  <strong>
                    {Number(totalWhitDiscount).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
                  </strong>
                </div>
                <div className="payment-flow-summary-row">
                  <span>Monto recibido</span>
                  <strong>
                    {Number(totalResivido).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}
                  </strong>
                </div>
                <div className="payment-flow-summary-row total">
                  <span>Cambio</span>
                  <strong>{Number(restMoney).toLocaleString("es-MX", { style: "currency", currency: "MXN" })}</strong>
                </div>
                <div className="payment-flow-summary-row customer">
                  <span>Cliente</span>
                  <strong>{ticketPaying.customer.name}</strong>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <div className="d-flex justify-content-end align-items-center w-100">
              <div className="d-flex gap-2">
                <Button color="success" onClick={() => finalizarVenta()}>
                  Finalizar Venta
                </Button>
                <Button color="secondary" onClick={toggleModal}>
                  Cerrar
                </Button>
              </div>
            </div>
          </ModalFooter>
          <Modal
            isOpen={isPagareCustomerModalOpen}
            toggle={() => setIsPagareCustomerModalOpen(false)}
            centered
            backdrop="static"
          >
            <ModalHeader toggle={() => setIsPagareCustomerModalOpen(false)}>Asignar pagare</ModalHeader>
            <ModalBody>
              <Label for="pagareCustomer">Cliente</Label>
              <AsyncSelect
                inputId="pagareCustomer"
                value={pagareCustomer}
                onChange={setPagareCustomer}
                loadOptions={loadCustomerOptions}
                defaultOptions
                isClearable={false}
                placeholder="Busca por nombre de cliente..."
                noOptionsMessage={() => "No se encontraron clientes"}
                loadingMessage={() => "Buscando..."}
              />
              <Alert color="info" className="mt-3 mb-0">
                El monto en pagare quedara asociado al cliente seleccionado.
              </Alert>
            </ModalBody>
            <ModalFooter>
              <Button color="warning" onClick={confirmarClientePagare}>
                Guardar pagare
              </Button>
              <Button color="secondary" onClick={() => setIsPagareCustomerModalOpen(false)}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>
        </>
      )}
    </Modal>
  )
}

OutPaiding.propTypes = {
  isOpen: propTypes.bool.isRequired,
  toggleModal: propTypes.func.isRequired,
  ticketPaying: propTypes.object.isRequired,
  setFinishSold: propTypes.func.isRequired,
}

export default OutPaiding
